module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/aig-811f5e673d94fed5d521434c0ad31ca2.png";